/**
 * Builds per-tile quantity text from an AEM section heading.
 * Example: count 10 + "Nightly Upgrade Awards" -> "10 Nightly Upgrade Awards"
 */
export const buildSectionQuantityLabel = (count: number, sectionHeading?: string): string => {
  if (!sectionHeading || count <= 0) {
    return '';
  }

  if (count === 1) {
    const singularHeading = sectionHeading.replace(/\s+Awards$/i, ' Award');
    return `1 ${singularHeading}`;
  }

  return `${count} ${sectionHeading}`;
};

export const getSectionQuantityLabels = (sectionHeading?: string): { singularLabel?: string; pluralLabel?: string } => {
  if (!sectionHeading) {
    return {};
  }

  return {
    singularLabel: sectionHeading.replace(/\s+Awards$/i, ' Award'),
    pluralLabel: sectionHeading,
  };
};
